import React, { useState } from 'react';
import { Grid, InputLabel, FormHelperText } from '@material-ui/core';
import { TextBox } from '../../../Core/FormInput';
import { SecondaryButton } from './../../../Core/FormInput/AppButton';
import { postApprovedJob } from '../../../Core/Service/CustUserCommunicator/communicator-service';
import AppContext from '../../../App/AppContext';
import { useContext } from 'react';
import { CustomeSignPad } from '../../../Core/SignaturePad';

const ApproveJobModal = (props) => {
    const { showToast } = useContext(AppContext);
    const [state, setState] = useState({
        error: {}
    });

    const GetTechnicianSign = (val) => {
        setState((st) => ({
            ...st,
            ...val
        }));
    };

    const clearSig = (val) => {
        setState((st) => ({
            ...st,
            customerSignature: null
        }));
    };

    let Validation = () => {
        let isValid = true;
        let error = {};
        if (!state.customerOrderReference) {
            isValid = false;
            error.customerOrderReference = 'Message is required';
        }
        if (!state.customerSignature) {
            isValid = false;
            error.customerSignature = 'Signature is required';
        }
        setState((st) => ({
            ...st,
            error: error
        }));
        return isValid;
    };

    const SubmitMessage = async () => {
        if (Validation()) {
            let data = {
                customerOrderReference: state.customerOrderReference,
                headerRecordID: props.headerRecordID,
                customerSignature: state.customerSignature
            };

            let res = await postApprovedJob(data);
            if (res.success) {
                showToast(`Job approved successfully`);
                props.onClose(true);
            } else {
                showToast(res.message);
            }
        }
    };

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setState((st) => ({ ...st, [name]: value }));
    };

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <InputLabel shrink className="mandatoryfields">
                        Approval Order Number
                    </InputLabel>
                    <TextBox onChange={handleFieldChange} name="customerOrderReference" value={state.customerOrderReference} />
                    <FormHelperText error>{state.error.customerOrderReference}</FormHelperText>
                </Grid>
                <Grid item xs={12}>
                    <CustomeSignPad
                        onChange={GetTechnicianSign}
                        content={'Signature'}
                        sign={state.customerSignature}
                        name="customerSignature"
                        clearSig={clearSig}
                    />
                    <FormHelperText error>{state.error.customerSignature}</FormHelperText>
                </Grid>
                <Grid item xs={12} style={{ marginBottom: 20 }}>
                    <SecondaryButton fullWidth onClick={SubmitMessage}>
                        Approve
                    </SecondaryButton>
                </Grid>
            </Grid>
        </div>
    );
};

export default ApproveJobModal;
